// source: apis/sparx/packages/v1/spxpkg.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
goog.exportSymbol('proto.sparx.packages.v1.Completion', null, global);
goog.exportSymbol('proto.sparx.packages.v1.CustomCompletion', null, global);
goog.exportSymbol('proto.sparx.packages.v1.DiagnosticTaskInfo', null, global);
goog.exportSymbol('proto.sparx.packages.v1.PackageCompletion', null, global);
goog.exportSymbol('proto.sparx.packages.v1.PackageContents', null, global);
goog.exportSymbol('proto.sparx.packages.v1.PackageData', null, global);
goog.exportSymbol('proto.sparx.packages.v1.PackageDates', null, global);
goog.exportSymbol('proto.sparx.packages.v1.PackageDetails', null, global);
goog.exportSymbol('proto.sparx.packages.v1.PackageRecipe', null, global);
goog.exportSymbol('proto.sparx.packages.v1.PackageStatus', null, global);
goog.exportSymbol('proto.sparx.packages.v1.PackageType', null, global);
goog.exportSymbol('proto.sparx.packages.v1.Rating', null, global);
goog.exportSymbol('proto.sparx.packages.v1.Task', null, global);
goog.exportSymbol('proto.sparx.packages.v1.TaskCompletion', null, global);
goog.exportSymbol('proto.sparx.packages.v1.TaskDeliveryFlags', null, global);
goog.exportSymbol('proto.sparx.packages.v1.TaskItem', null, global);
goog.exportSymbol('proto.sparx.packages.v1.TaskItemCompletion', null, global);
goog.exportSymbol('proto.sparx.packages.v1.TaskItemFlag', null, global);
goog.exportSymbol('proto.sparx.packages.v1.TaskItemStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.PackageDates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sparx.packages.v1.PackageDates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.PackageDates.displayName = 'proto.sparx.packages.v1.PackageDates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.PackageDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sparx.packages.v1.PackageDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.PackageDetails.displayName = 'proto.sparx.packages.v1.PackageDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.PackageContents = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sparx.packages.v1.PackageContents.repeatedFields_, null);
};
goog.inherits(proto.sparx.packages.v1.PackageContents, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.PackageContents.displayName = 'proto.sparx.packages.v1.PackageContents';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.DiagnosticTaskInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sparx.packages.v1.DiagnosticTaskInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.DiagnosticTaskInfo.displayName = 'proto.sparx.packages.v1.DiagnosticTaskInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.Task = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sparx.packages.v1.Task.repeatedFields_, null);
};
goog.inherits(proto.sparx.packages.v1.Task, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.Task.displayName = 'proto.sparx.packages.v1.Task';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.CustomCompletion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sparx.packages.v1.CustomCompletion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.CustomCompletion.displayName = 'proto.sparx.packages.v1.CustomCompletion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.TaskItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sparx.packages.v1.TaskItem.repeatedFields_, null);
};
goog.inherits(proto.sparx.packages.v1.TaskItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.TaskItem.displayName = 'proto.sparx.packages.v1.TaskItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.PackageRecipe = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sparx.packages.v1.PackageRecipe, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.PackageRecipe.displayName = 'proto.sparx.packages.v1.PackageRecipe';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.PackageData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sparx.packages.v1.PackageData.repeatedFields_, null);
};
goog.inherits(proto.sparx.packages.v1.PackageData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.PackageData.displayName = 'proto.sparx.packages.v1.PackageData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.PackageCompletion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sparx.packages.v1.PackageCompletion.repeatedFields_, null);
};
goog.inherits(proto.sparx.packages.v1.PackageCompletion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.PackageCompletion.displayName = 'proto.sparx.packages.v1.PackageCompletion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.TaskCompletion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sparx.packages.v1.TaskCompletion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.TaskCompletion.displayName = 'proto.sparx.packages.v1.TaskCompletion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.TaskItemCompletion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sparx.packages.v1.TaskItemCompletion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.TaskItemCompletion.displayName = 'proto.sparx.packages.v1.TaskItemCompletion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.Rating = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sparx.packages.v1.Rating, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.Rating.displayName = 'proto.sparx.packages.v1.Rating';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sparx.packages.v1.Completion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sparx.packages.v1.Completion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sparx.packages.v1.Completion.displayName = 'proto.sparx.packages.v1.Completion';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.PackageDates.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.PackageDates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.PackageDates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageDates.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: (f = msg.getStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    end: (f = msg.getEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    expiry: (f = msg.getExpiry()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.PackageDates}
 */
proto.sparx.packages.v1.PackageDates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.PackageDates;
  return proto.sparx.packages.v1.PackageDates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.PackageDates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.PackageDates}
 */
proto.sparx.packages.v1.PackageDates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEnd(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.PackageDates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.PackageDates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.PackageDates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageDates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEnd();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExpiry();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp start = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.sparx.packages.v1.PackageDates.prototype.getStart = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.sparx.packages.v1.PackageDates} returns this
*/
proto.sparx.packages.v1.PackageDates.prototype.setStart = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.PackageDates} returns this
 */
proto.sparx.packages.v1.PackageDates.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageDates.prototype.hasStart = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.sparx.packages.v1.PackageDates.prototype.getEnd = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.sparx.packages.v1.PackageDates} returns this
*/
proto.sparx.packages.v1.PackageDates.prototype.setEnd = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.PackageDates} returns this
 */
proto.sparx.packages.v1.PackageDates.prototype.clearEnd = function() {
  return this.setEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageDates.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp expiry = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.sparx.packages.v1.PackageDates.prototype.getExpiry = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.sparx.packages.v1.PackageDates} returns this
*/
proto.sparx.packages.v1.PackageDates.prototype.setExpiry = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.PackageDates} returns this
 */
proto.sparx.packages.v1.PackageDates.prototype.clearExpiry = function() {
  return this.setExpiry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageDates.prototype.hasExpiry = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.PackageDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.PackageDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.PackageDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    packageid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dates: (f = msg.getDates()) && proto.sparx.packages.v1.PackageDates.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    contents: (f = msg.getContents()) && proto.sparx.packages.v1.PackageContents.toObject(includeInstance, f),
    title: jspb.Message.getFieldWithDefault(msg, 6, ""),
    isdiagnosticpackage: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    numdiagnostictasks: jspb.Message.getFieldWithDefault(msg, 8, 0),
    followonpackageid: jspb.Message.getFieldWithDefault(msg, 9, ""),
    startingdiagnosticlevel: jspb.Message.getFieldWithDefault(msg, 10, 0),
    labelsMap: (f = msg.getLabelsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.PackageDetails}
 */
proto.sparx.packages.v1.PackageDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.PackageDetails;
  return proto.sparx.packages.v1.PackageDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.PackageDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.PackageDetails}
 */
proto.sparx.packages.v1.PackageDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.sparx.packages.v1.PackageType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageid(value);
      break;
    case 3:
      var value = new proto.sparx.packages.v1.PackageDates;
      reader.readMessage(value,proto.sparx.packages.v1.PackageDates.deserializeBinaryFromReader);
      msg.setDates(value);
      break;
    case 4:
      var value = /** @type {!proto.sparx.packages.v1.PackageStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new proto.sparx.packages.v1.PackageContents;
      reader.readMessage(value,proto.sparx.packages.v1.PackageContents.deserializeBinaryFromReader);
      msg.setContents(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsdiagnosticpackage(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNumdiagnostictasks(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFollowonpackageid(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartingdiagnosticlevel(value);
      break;
    case 12:
      var value = msg.getLabelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.PackageDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.PackageDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.PackageDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPackageid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDates();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.sparx.packages.v1.PackageDates.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getContents();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.sparx.packages.v1.PackageContents.serializeBinaryToWriter
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIsdiagnosticpackage();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getNumdiagnostictasks();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getFollowonpackageid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getStartingdiagnosticlevel();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getLabelsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(12, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional PackageType type = 1;
 * @return {!proto.sparx.packages.v1.PackageType}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getType = function() {
  return /** @type {!proto.sparx.packages.v1.PackageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.sparx.packages.v1.PackageType} value
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string packageID = 2;
 * @return {string}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getPackageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional PackageDates dates = 3;
 * @return {?proto.sparx.packages.v1.PackageDates}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getDates = function() {
  return /** @type{?proto.sparx.packages.v1.PackageDates} */ (
    jspb.Message.getWrapperField(this, proto.sparx.packages.v1.PackageDates, 3));
};


/**
 * @param {?proto.sparx.packages.v1.PackageDates|undefined} value
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
*/
proto.sparx.packages.v1.PackageDetails.prototype.setDates = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.clearDates = function() {
  return this.setDates(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageDetails.prototype.hasDates = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PackageStatus status = 4;
 * @return {!proto.sparx.packages.v1.PackageStatus}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getStatus = function() {
  return /** @type {!proto.sparx.packages.v1.PackageStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.sparx.packages.v1.PackageStatus} value
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional PackageContents contents = 5;
 * @return {?proto.sparx.packages.v1.PackageContents}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getContents = function() {
  return /** @type{?proto.sparx.packages.v1.PackageContents} */ (
    jspb.Message.getWrapperField(this, proto.sparx.packages.v1.PackageContents, 5));
};


/**
 * @param {?proto.sparx.packages.v1.PackageContents|undefined} value
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
*/
proto.sparx.packages.v1.PackageDetails.prototype.setContents = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.clearContents = function() {
  return this.setContents(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageDetails.prototype.hasContents = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string title = 6;
 * @return {string}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool isDiagnosticPackage = 7;
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getIsdiagnosticpackage = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.setIsdiagnosticpackage = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional int64 numDiagnosticTasks = 8;
 * @return {number}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getNumdiagnostictasks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.setNumdiagnostictasks = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string followOnPackageID = 9;
 * @return {string}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getFollowonpackageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.setFollowonpackageid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 startingDiagnosticLevel = 10;
 * @return {number}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getStartingdiagnosticlevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.setStartingdiagnosticlevel = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * map<string, string> labels = 12;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.sparx.packages.v1.PackageDetails.prototype.getLabelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 12, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.sparx.packages.v1.PackageDetails} returns this
 */
proto.sparx.packages.v1.PackageDetails.prototype.clearLabelsMap = function() {
  this.getLabelsMap().clear();
  return this;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sparx.packages.v1.PackageContents.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.PackageContents.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.PackageContents.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.PackageContents} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageContents.toObject = function(includeInstance, msg) {
  var f, obj = {
    tasksList: jspb.Message.toObjectList(msg.getTasksList(),
    proto.sparx.packages.v1.Task.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.PackageContents}
 */
proto.sparx.packages.v1.PackageContents.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.PackageContents;
  return proto.sparx.packages.v1.PackageContents.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.PackageContents} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.PackageContents}
 */
proto.sparx.packages.v1.PackageContents.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.sparx.packages.v1.Task;
      reader.readMessage(value,proto.sparx.packages.v1.Task.deserializeBinaryFromReader);
      msg.addTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.PackageContents.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.PackageContents.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.PackageContents} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageContents.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.sparx.packages.v1.Task.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Task tasks = 1;
 * @return {!Array<!proto.sparx.packages.v1.Task>}
 */
proto.sparx.packages.v1.PackageContents.prototype.getTasksList = function() {
  return /** @type{!Array<!proto.sparx.packages.v1.Task>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sparx.packages.v1.Task, 1));
};


/**
 * @param {!Array<!proto.sparx.packages.v1.Task>} value
 * @return {!proto.sparx.packages.v1.PackageContents} returns this
*/
proto.sparx.packages.v1.PackageContents.prototype.setTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.sparx.packages.v1.Task=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sparx.packages.v1.Task}
 */
proto.sparx.packages.v1.PackageContents.prototype.addTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.sparx.packages.v1.Task, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sparx.packages.v1.PackageContents} returns this
 */
proto.sparx.packages.v1.PackageContents.prototype.clearTasksList = function() {
  return this.setTasksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.DiagnosticTaskInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.DiagnosticTaskInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    diagnosticlevel: jspb.Message.getFieldWithDefault(msg, 9, 0),
    diagnosticleveltaskindex: jspb.Message.getFieldWithDefault(msg, 10, 0),
    moveupmaxtimetaken: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    moveupminpropcorrectfirsttime: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    samelevelminpropcorrectfirsttime: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.DiagnosticTaskInfo}
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.DiagnosticTaskInfo;
  return proto.sparx.packages.v1.DiagnosticTaskInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.DiagnosticTaskInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.DiagnosticTaskInfo}
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiagnosticlevel(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiagnosticleveltaskindex(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMoveupmaxtimetaken(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMoveupminpropcorrectfirsttime(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSamelevelminpropcorrectfirsttime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.DiagnosticTaskInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.DiagnosticTaskInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiagnosticlevel();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getDiagnosticleveltaskindex();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getMoveupmaxtimetaken();
  if (f !== 0.0) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = message.getMoveupminpropcorrectfirsttime();
  if (f !== 0.0) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = message.getSamelevelminpropcorrectfirsttime();
  if (f !== 0.0) {
    writer.writeFloat(
      13,
      f
    );
  }
};


/**
 * optional int64 diagnosticLevel = 9;
 * @return {number}
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.getDiagnosticlevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.DiagnosticTaskInfo} returns this
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.setDiagnosticlevel = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 diagnosticLevelTaskIndex = 10;
 * @return {number}
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.getDiagnosticleveltaskindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.DiagnosticTaskInfo} returns this
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.setDiagnosticleveltaskindex = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional float moveUpMaxTimeTaken = 11;
 * @return {number}
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.getMoveupmaxtimetaken = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.DiagnosticTaskInfo} returns this
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.setMoveupmaxtimetaken = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional float moveUpMinPropCorrectFirstTime = 12;
 * @return {number}
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.getMoveupminpropcorrectfirsttime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.DiagnosticTaskInfo} returns this
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.setMoveupminpropcorrectfirsttime = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional float sameLevelMinPropCorrectFirstTime = 13;
 * @return {number}
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.getSamelevelminpropcorrectfirsttime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.DiagnosticTaskInfo} returns this
 */
proto.sparx.packages.v1.DiagnosticTaskInfo.prototype.setSamelevelminpropcorrectfirsttime = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sparx.packages.v1.Task.repeatedFields_ = [1,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.Task.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.Task.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.Task} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.Task.toObject = function(includeInstance, msg) {
  var f, obj = {
    taskitemsList: jspb.Message.toObjectList(msg.getTaskitemsList(),
    proto.sparx.packages.v1.TaskItem.toObject, includeInstance),
    rewardxpoints: jspb.Message.getFieldWithDefault(msg, 2, 0),
    tasktype: jspb.Message.getFieldWithDefault(msg, 3, ""),
    donotwac: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    title: jspb.Message.getFieldWithDefault(msg, 5, ""),
    flagsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    completion: (f = msg.getCompletion()) && proto.sparx.packages.v1.CustomCompletion.toObject(includeInstance, f),
    completionstore: jspb.Message.getFieldWithDefault(msg, 8, ""),
    diagnostictaskinfo: (f = msg.getDiagnostictaskinfo()) && proto.sparx.packages.v1.DiagnosticTaskInfo.toObject(includeInstance, f),
    section: jspb.Message.getFieldWithDefault(msg, 10, ""),
    stage: jspb.Message.getFieldWithDefault(msg, 11, ""),
    labelsMap: (f = msg.getLabelsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.Task}
 */
proto.sparx.packages.v1.Task.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.Task;
  return proto.sparx.packages.v1.Task.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.Task} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.Task}
 */
proto.sparx.packages.v1.Task.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.sparx.packages.v1.TaskItem;
      reader.readMessage(value,proto.sparx.packages.v1.TaskItem.deserializeBinaryFromReader);
      msg.addTaskitems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRewardxpoints(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTasktype(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDonotwac(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 6:
      var values = /** @type {!Array<!proto.sparx.packages.v1.TaskDeliveryFlags>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFlags(values[i]);
      }
      break;
    case 7:
      var value = new proto.sparx.packages.v1.CustomCompletion;
      reader.readMessage(value,proto.sparx.packages.v1.CustomCompletion.deserializeBinaryFromReader);
      msg.setCompletion(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletionstore(value);
      break;
    case 9:
      var value = new proto.sparx.packages.v1.DiagnosticTaskInfo;
      reader.readMessage(value,proto.sparx.packages.v1.DiagnosticTaskInfo.deserializeBinaryFromReader);
      msg.setDiagnostictaskinfo(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSection(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setStage(value);
      break;
    case 12:
      var value = msg.getLabelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.Task.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.Task.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.Task} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.Task.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskitemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.sparx.packages.v1.TaskItem.serializeBinaryToWriter
    );
  }
  f = message.getRewardxpoints();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTasktype();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDonotwac();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFlagsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getCompletion();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.sparx.packages.v1.CustomCompletion.serializeBinaryToWriter
    );
  }
  f = message.getCompletionstore();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDiagnostictaskinfo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.sparx.packages.v1.DiagnosticTaskInfo.serializeBinaryToWriter
    );
  }
  f = message.getSection();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getStage();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLabelsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(12, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * repeated TaskItem taskItems = 1;
 * @return {!Array<!proto.sparx.packages.v1.TaskItem>}
 */
proto.sparx.packages.v1.Task.prototype.getTaskitemsList = function() {
  return /** @type{!Array<!proto.sparx.packages.v1.TaskItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sparx.packages.v1.TaskItem, 1));
};


/**
 * @param {!Array<!proto.sparx.packages.v1.TaskItem>} value
 * @return {!proto.sparx.packages.v1.Task} returns this
*/
proto.sparx.packages.v1.Task.prototype.setTaskitemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.sparx.packages.v1.TaskItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sparx.packages.v1.TaskItem}
 */
proto.sparx.packages.v1.Task.prototype.addTaskitems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.sparx.packages.v1.TaskItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.clearTaskitemsList = function() {
  return this.setTaskitemsList([]);
};


/**
 * optional int64 rewardXPoints = 2;
 * @return {number}
 */
proto.sparx.packages.v1.Task.prototype.getRewardxpoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.setRewardxpoints = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string taskType = 3;
 * @return {string}
 */
proto.sparx.packages.v1.Task.prototype.getTasktype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.setTasktype = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool doNotWAC = 4;
 * @return {boolean}
 */
proto.sparx.packages.v1.Task.prototype.getDonotwac = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.setDonotwac = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string title = 5;
 * @return {string}
 */
proto.sparx.packages.v1.Task.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated TaskDeliveryFlags flags = 6;
 * @return {!Array<!proto.sparx.packages.v1.TaskDeliveryFlags>}
 */
proto.sparx.packages.v1.Task.prototype.getFlagsList = function() {
  return /** @type {!Array<!proto.sparx.packages.v1.TaskDeliveryFlags>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.sparx.packages.v1.TaskDeliveryFlags>} value
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.setFlagsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.sparx.packages.v1.TaskDeliveryFlags} value
 * @param {number=} opt_index
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.addFlags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.clearFlagsList = function() {
  return this.setFlagsList([]);
};


/**
 * optional CustomCompletion completion = 7;
 * @return {?proto.sparx.packages.v1.CustomCompletion}
 */
proto.sparx.packages.v1.Task.prototype.getCompletion = function() {
  return /** @type{?proto.sparx.packages.v1.CustomCompletion} */ (
    jspb.Message.getWrapperField(this, proto.sparx.packages.v1.CustomCompletion, 7));
};


/**
 * @param {?proto.sparx.packages.v1.CustomCompletion|undefined} value
 * @return {!proto.sparx.packages.v1.Task} returns this
*/
proto.sparx.packages.v1.Task.prototype.setCompletion = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.clearCompletion = function() {
  return this.setCompletion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.Task.prototype.hasCompletion = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string completionStore = 8;
 * @return {string}
 */
proto.sparx.packages.v1.Task.prototype.getCompletionstore = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.setCompletionstore = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional DiagnosticTaskInfo diagnosticTaskInfo = 9;
 * @return {?proto.sparx.packages.v1.DiagnosticTaskInfo}
 */
proto.sparx.packages.v1.Task.prototype.getDiagnostictaskinfo = function() {
  return /** @type{?proto.sparx.packages.v1.DiagnosticTaskInfo} */ (
    jspb.Message.getWrapperField(this, proto.sparx.packages.v1.DiagnosticTaskInfo, 9));
};


/**
 * @param {?proto.sparx.packages.v1.DiagnosticTaskInfo|undefined} value
 * @return {!proto.sparx.packages.v1.Task} returns this
*/
proto.sparx.packages.v1.Task.prototype.setDiagnostictaskinfo = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.clearDiagnostictaskinfo = function() {
  return this.setDiagnostictaskinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.Task.prototype.hasDiagnostictaskinfo = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string section = 10;
 * @return {string}
 */
proto.sparx.packages.v1.Task.prototype.getSection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.setSection = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string stage = 11;
 * @return {string}
 */
proto.sparx.packages.v1.Task.prototype.getStage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.setStage = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * map<string, string> labels = 12;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.sparx.packages.v1.Task.prototype.getLabelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 12, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.sparx.packages.v1.Task} returns this
 */
proto.sparx.packages.v1.Task.prototype.clearLabelsMap = function() {
  this.getLabelsMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.CustomCompletion.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.CustomCompletion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.CustomCompletion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.CustomCompletion.toObject = function(includeInstance, msg) {
  var f, obj = {
    size: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    weight: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.CustomCompletion}
 */
proto.sparx.packages.v1.CustomCompletion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.CustomCompletion;
  return proto.sparx.packages.v1.CustomCompletion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.CustomCompletion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.CustomCompletion}
 */
proto.sparx.packages.v1.CustomCompletion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.CustomCompletion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.CustomCompletion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.CustomCompletion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.CustomCompletion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSize();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double size = 1;
 * @return {number}
 */
proto.sparx.packages.v1.CustomCompletion.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.CustomCompletion} returns this
 */
proto.sparx.packages.v1.CustomCompletion.prototype.setSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double weight = 2;
 * @return {number}
 */
proto.sparx.packages.v1.CustomCompletion.prototype.getWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.CustomCompletion} returns this
 */
proto.sparx.packages.v1.CustomCompletion.prototype.setWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sparx.packages.v1.TaskItem.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.TaskItem.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.TaskItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.TaskItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.TaskItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    skillid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    learningunitid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    repeatquestion: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    questionid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    customquestion: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    flagsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    labelsMap: (f = msg.getLabelsMap()) ? f.toObject(includeInstance, undefined) : [],
    curriculumtopicname: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.TaskItem}
 */
proto.sparx.packages.v1.TaskItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.TaskItem;
  return proto.sparx.packages.v1.TaskItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.TaskItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.TaskItem}
 */
proto.sparx.packages.v1.TaskItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSkillid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLearningunitid(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRepeatquestion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomquestion(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var values = /** @type {!Array<!proto.sparx.packages.v1.TaskItemFlag>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFlags(values[i]);
      }
      break;
    case 8:
      var value = msg.getLabelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurriculumtopicname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.TaskItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.TaskItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.TaskItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.TaskItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkillid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLearningunitid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRepeatquestion();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getQuestionid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCustomquestion();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFlagsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
  f = message.getLabelsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCurriculumtopicname();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string skillID = 1;
 * @return {string}
 */
proto.sparx.packages.v1.TaskItem.prototype.getSkillid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.setSkillid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string learningUnitID = 2;
 * @return {string}
 */
proto.sparx.packages.v1.TaskItem.prototype.getLearningunitid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.setLearningunitid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool repeatQuestion = 3;
 * @return {boolean}
 */
proto.sparx.packages.v1.TaskItem.prototype.getRepeatquestion = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.setRepeatquestion = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string questionID = 4;
 * @return {string}
 */
proto.sparx.packages.v1.TaskItem.prototype.getQuestionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.setQuestionid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string customQuestion = 5;
 * @return {string}
 */
proto.sparx.packages.v1.TaskItem.prototype.getCustomquestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.setCustomquestion = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.sparx.packages.v1.TaskItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated TaskItemFlag flags = 7;
 * @return {!Array<!proto.sparx.packages.v1.TaskItemFlag>}
 */
proto.sparx.packages.v1.TaskItem.prototype.getFlagsList = function() {
  return /** @type {!Array<!proto.sparx.packages.v1.TaskItemFlag>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.sparx.packages.v1.TaskItemFlag>} value
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.setFlagsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.sparx.packages.v1.TaskItemFlag} value
 * @param {number=} opt_index
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.addFlags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.clearFlagsList = function() {
  return this.setFlagsList([]);
};


/**
 * map<string, string> labels = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.sparx.packages.v1.TaskItem.prototype.getLabelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.clearLabelsMap = function() {
  this.getLabelsMap().clear();
  return this;
};


/**
 * optional string curriculumTopicName = 9;
 * @return {string}
 */
proto.sparx.packages.v1.TaskItem.prototype.getCurriculumtopicname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskItem} returns this
 */
proto.sparx.packages.v1.TaskItem.prototype.setCurriculumtopicname = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.PackageRecipe.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.PackageRecipe.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.PackageRecipe} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageRecipe.toObject = function(includeInstance, msg) {
  var f, obj = {
    packagerRequest: (f = msg.getPackagerRequest()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.PackageRecipe}
 */
proto.sparx.packages.v1.PackageRecipe.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.PackageRecipe;
  return proto.sparx.packages.v1.PackageRecipe.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.PackageRecipe} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.PackageRecipe}
 */
proto.sparx.packages.v1.PackageRecipe.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setPackagerRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.PackageRecipe.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.PackageRecipe.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.PackageRecipe} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageRecipe.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackagerRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Any packager_request = 1;
 * @return {?proto.google.protobuf.Any}
 */
proto.sparx.packages.v1.PackageRecipe.prototype.getPackagerRequest = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 1));
};


/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.sparx.packages.v1.PackageRecipe} returns this
*/
proto.sparx.packages.v1.PackageRecipe.prototype.setPackagerRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.PackageRecipe} returns this
 */
proto.sparx.packages.v1.PackageRecipe.prototype.clearPackagerRequest = function() {
  return this.setPackagerRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageRecipe.prototype.hasPackagerRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sparx.packages.v1.PackageData.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.PackageData.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.PackageData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.PackageData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageData.toObject = function(includeInstance, msg) {
  var f, obj = {
    packagesList: jspb.Message.toObjectList(msg.getPackagesList(),
    proto.sparx.packages.v1.PackageCompletion.toObject, includeInstance),
    tasksList: jspb.Message.toObjectList(msg.getTasksList(),
    proto.sparx.packages.v1.TaskCompletion.toObject, includeInstance),
    taskitemsList: jspb.Message.toObjectList(msg.getTaskitemsList(),
    proto.sparx.packages.v1.TaskItemCompletion.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.PackageData}
 */
proto.sparx.packages.v1.PackageData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.PackageData;
  return proto.sparx.packages.v1.PackageData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.PackageData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.PackageData}
 */
proto.sparx.packages.v1.PackageData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.sparx.packages.v1.PackageCompletion;
      reader.readMessage(value,proto.sparx.packages.v1.PackageCompletion.deserializeBinaryFromReader);
      msg.addPackages(value);
      break;
    case 2:
      var value = new proto.sparx.packages.v1.TaskCompletion;
      reader.readMessage(value,proto.sparx.packages.v1.TaskCompletion.deserializeBinaryFromReader);
      msg.addTasks(value);
      break;
    case 3:
      var value = new proto.sparx.packages.v1.TaskItemCompletion;
      reader.readMessage(value,proto.sparx.packages.v1.TaskItemCompletion.deserializeBinaryFromReader);
      msg.addTaskitems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.PackageData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.PackageData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.PackageData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.sparx.packages.v1.PackageCompletion.serializeBinaryToWriter
    );
  }
  f = message.getTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.sparx.packages.v1.TaskCompletion.serializeBinaryToWriter
    );
  }
  f = message.getTaskitemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.sparx.packages.v1.TaskItemCompletion.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PackageCompletion packages = 1;
 * @return {!Array<!proto.sparx.packages.v1.PackageCompletion>}
 */
proto.sparx.packages.v1.PackageData.prototype.getPackagesList = function() {
  return /** @type{!Array<!proto.sparx.packages.v1.PackageCompletion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sparx.packages.v1.PackageCompletion, 1));
};


/**
 * @param {!Array<!proto.sparx.packages.v1.PackageCompletion>} value
 * @return {!proto.sparx.packages.v1.PackageData} returns this
*/
proto.sparx.packages.v1.PackageData.prototype.setPackagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.sparx.packages.v1.PackageCompletion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sparx.packages.v1.PackageCompletion}
 */
proto.sparx.packages.v1.PackageData.prototype.addPackages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.sparx.packages.v1.PackageCompletion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sparx.packages.v1.PackageData} returns this
 */
proto.sparx.packages.v1.PackageData.prototype.clearPackagesList = function() {
  return this.setPackagesList([]);
};


/**
 * repeated TaskCompletion tasks = 2;
 * @return {!Array<!proto.sparx.packages.v1.TaskCompletion>}
 */
proto.sparx.packages.v1.PackageData.prototype.getTasksList = function() {
  return /** @type{!Array<!proto.sparx.packages.v1.TaskCompletion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sparx.packages.v1.TaskCompletion, 2));
};


/**
 * @param {!Array<!proto.sparx.packages.v1.TaskCompletion>} value
 * @return {!proto.sparx.packages.v1.PackageData} returns this
*/
proto.sparx.packages.v1.PackageData.prototype.setTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.sparx.packages.v1.TaskCompletion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sparx.packages.v1.TaskCompletion}
 */
proto.sparx.packages.v1.PackageData.prototype.addTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.sparx.packages.v1.TaskCompletion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sparx.packages.v1.PackageData} returns this
 */
proto.sparx.packages.v1.PackageData.prototype.clearTasksList = function() {
  return this.setTasksList([]);
};


/**
 * repeated TaskItemCompletion taskItems = 3;
 * @return {!Array<!proto.sparx.packages.v1.TaskItemCompletion>}
 */
proto.sparx.packages.v1.PackageData.prototype.getTaskitemsList = function() {
  return /** @type{!Array<!proto.sparx.packages.v1.TaskItemCompletion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sparx.packages.v1.TaskItemCompletion, 3));
};


/**
 * @param {!Array<!proto.sparx.packages.v1.TaskItemCompletion>} value
 * @return {!proto.sparx.packages.v1.PackageData} returns this
*/
proto.sparx.packages.v1.PackageData.prototype.setTaskitemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.sparx.packages.v1.TaskItemCompletion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sparx.packages.v1.TaskItemCompletion}
 */
proto.sparx.packages.v1.PackageData.prototype.addTaskitems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.sparx.packages.v1.TaskItemCompletion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sparx.packages.v1.PackageData} returns this
 */
proto.sparx.packages.v1.PackageData.prototype.clearTaskitemsList = function() {
  return this.setTaskitemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sparx.packages.v1.PackageCompletion.repeatedFields_ = [15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.PackageCompletion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.PackageCompletion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageCompletion.toObject = function(includeInstance, msg) {
  var f, obj = {
    packageid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    startdate: (f = msg.getStartdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    enddate: (f = msg.getEnddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    title: jspb.Message.getFieldWithDefault(msg, 4, ""),
    packagetype: jspb.Message.getFieldWithDefault(msg, 5, ""),
    numtasks: jspb.Message.getFieldWithDefault(msg, 6, 0),
    numtaskitems: jspb.Message.getFieldWithDefault(msg, 7, 0),
    numtaskitemsdone: jspb.Message.getFieldWithDefault(msg, 8, 0),
    hasbeencomplete: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    numtaskscomplete: jspb.Message.getFieldWithDefault(msg, 10, 0),
    numtasksinprogress: jspb.Message.getFieldWithDefault(msg, 11, 0),
    status: jspb.Message.getFieldWithDefault(msg, 12, ""),
    xpoints: jspb.Message.getFieldWithDefault(msg, 13, 0),
    completion: (f = msg.getCompletion()) && proto.sparx.packages.v1.Completion.toObject(includeInstance, f),
    taskidsList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f,
    labelsMap: (f = msg.getLabelsMap()) ? f.toObject(includeInstance, undefined) : [],
    deletedtime: (f = msg.getDeletedtime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.PackageCompletion}
 */
proto.sparx.packages.v1.PackageCompletion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.PackageCompletion;
  return proto.sparx.packages.v1.PackageCompletion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.PackageCompletion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.PackageCompletion}
 */
proto.sparx.packages.v1.PackageCompletion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageid(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartdate(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEnddate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackagetype(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumtasks(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumtaskitems(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumtaskitemsdone(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasbeencomplete(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumtaskscomplete(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumtasksinprogress(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setXpoints(value);
      break;
    case 14:
      var value = new proto.sparx.packages.v1.Completion;
      reader.readMessage(value,proto.sparx.packages.v1.Completion.deserializeBinaryFromReader);
      msg.setCompletion(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.addTaskids(value);
      break;
    case 16:
      var value = msg.getLabelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeletedtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.PackageCompletion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.PackageCompletion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.PackageCompletion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartdate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEnddate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPackagetype();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNumtasks();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getNumtaskitems();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getNumtaskitemsdone();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getHasbeencomplete();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getNumtaskscomplete();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getNumtasksinprogress();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getXpoints();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getCompletion();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.sparx.packages.v1.Completion.serializeBinaryToWriter
    );
  }
  f = message.getTaskidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      15,
      f
    );
  }
  f = message.getLabelsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(16, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getDeletedtime();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string packageID = 1;
 * @return {string}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getPackageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp startDate = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getStartdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
*/
proto.sparx.packages.v1.PackageCompletion.prototype.setStartdate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.clearStartdate = function() {
  return this.setStartdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.hasStartdate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp endDate = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getEnddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
*/
proto.sparx.packages.v1.PackageCompletion.prototype.setEnddate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.clearEnddate = function() {
  return this.setEnddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.hasEnddate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string packageType = 5;
 * @return {string}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getPackagetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setPackagetype = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int32 numTasks = 6;
 * @return {number}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getNumtasks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setNumtasks = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 numTaskItems = 7;
 * @return {number}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getNumtaskitems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setNumtaskitems = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 numTaskItemsDone = 8;
 * @return {number}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getNumtaskitemsdone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setNumtaskitemsdone = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool hasBeenComplete = 9;
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getHasbeencomplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setHasbeencomplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional int32 numTasksComplete = 10;
 * @return {number}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getNumtaskscomplete = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setNumtaskscomplete = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 numTasksInProgress = 11;
 * @return {number}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getNumtasksinprogress = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setNumtasksinprogress = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string status = 12;
 * @return {string}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int32 xPoints = 13;
 * @return {number}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getXpoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setXpoints = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional Completion completion = 14;
 * @return {?proto.sparx.packages.v1.Completion}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getCompletion = function() {
  return /** @type{?proto.sparx.packages.v1.Completion} */ (
    jspb.Message.getWrapperField(this, proto.sparx.packages.v1.Completion, 14));
};


/**
 * @param {?proto.sparx.packages.v1.Completion|undefined} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
*/
proto.sparx.packages.v1.PackageCompletion.prototype.setCompletion = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.clearCompletion = function() {
  return this.setCompletion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.hasCompletion = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * repeated string taskIds = 15;
 * @return {!Array<string>}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getTaskidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.setTaskidsList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.addTaskids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.clearTaskidsList = function() {
  return this.setTaskidsList([]);
};


/**
 * map<string, string> labels = 16;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getLabelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 16, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.clearLabelsMap = function() {
  this.getLabelsMap().clear();
  return this;
};


/**
 * optional google.protobuf.Timestamp deletedTime = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.getDeletedtime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
*/
proto.sparx.packages.v1.PackageCompletion.prototype.setDeletedtime = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.PackageCompletion} returns this
 */
proto.sparx.packages.v1.PackageCompletion.prototype.clearDeletedtime = function() {
  return this.setDeletedtime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.PackageCompletion.prototype.hasDeletedtime = function() {
  return jspb.Message.getField(this, 17) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.TaskCompletion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.TaskCompletion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.TaskCompletion.toObject = function(includeInstance, msg) {
  var f, obj = {
    packageid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    taskindex: jspb.Message.getFieldWithDefault(msg, 2, 0),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tasktype: jspb.Message.getFieldWithDefault(msg, 4, ""),
    numtaskitems: jspb.Message.getFieldWithDefault(msg, 6, 0),
    numtaskitemsdone: jspb.Message.getFieldWithDefault(msg, 7, 0),
    hasbeencomplete: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    numtaskitemswrong: jspb.Message.getFieldWithDefault(msg, 9, 0),
    donotwac: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    completion: (f = msg.getCompletion()) && proto.sparx.packages.v1.Completion.toObject(includeInstance, f),
    completionstore: jspb.Message.getFieldWithDefault(msg, 12, ""),
    labelsMap: (f = msg.getLabelsMap()) ? f.toObject(includeInstance, undefined) : [],
    fixedquestiondelivery: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    secondchancedelivery: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.TaskCompletion}
 */
proto.sparx.packages.v1.TaskCompletion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.TaskCompletion;
  return proto.sparx.packages.v1.TaskCompletion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.TaskCompletion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.TaskCompletion}
 */
proto.sparx.packages.v1.TaskCompletion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTaskindex(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTasktype(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumtaskitems(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumtaskitemsdone(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasbeencomplete(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumtaskitemswrong(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDonotwac(value);
      break;
    case 11:
      var value = new proto.sparx.packages.v1.Completion;
      reader.readMessage(value,proto.sparx.packages.v1.Completion.deserializeBinaryFromReader);
      msg.setCompletion(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompletionstore(value);
      break;
    case 13:
      var value = msg.getLabelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFixedquestiondelivery(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSecondchancedelivery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.TaskCompletion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.TaskCompletion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.TaskCompletion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskindex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTasktype();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNumtaskitems();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getNumtaskitemsdone();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getHasbeencomplete();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getNumtaskitemswrong();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getDonotwac();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getCompletion();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.sparx.packages.v1.Completion.serializeBinaryToWriter
    );
  }
  f = message.getCompletionstore();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLabelsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(13, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getFixedquestiondelivery();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getSecondchancedelivery();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional string packageID = 1;
 * @return {string}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getPackageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 taskIndex = 2;
 * @return {number}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getTaskindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setTaskindex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string taskType = 4;
 * @return {string}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getTasktype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setTasktype = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 numTaskItems = 6;
 * @return {number}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getNumtaskitems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setNumtaskitems = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 numTaskItemsDone = 7;
 * @return {number}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getNumtaskitemsdone = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setNumtaskitemsdone = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool hasBeenComplete = 8;
 * @return {boolean}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getHasbeencomplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setHasbeencomplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int32 numTaskItemsWrong = 9;
 * @return {number}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getNumtaskitemswrong = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setNumtaskitemswrong = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool doNotWAC = 10;
 * @return {boolean}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getDonotwac = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setDonotwac = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional Completion completion = 11;
 * @return {?proto.sparx.packages.v1.Completion}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getCompletion = function() {
  return /** @type{?proto.sparx.packages.v1.Completion} */ (
    jspb.Message.getWrapperField(this, proto.sparx.packages.v1.Completion, 11));
};


/**
 * @param {?proto.sparx.packages.v1.Completion|undefined} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
*/
proto.sparx.packages.v1.TaskCompletion.prototype.setCompletion = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.clearCompletion = function() {
  return this.setCompletion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.hasCompletion = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string completionStore = 12;
 * @return {string}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getCompletionstore = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setCompletionstore = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * map<string, string> labels = 13;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getLabelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 13, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.clearLabelsMap = function() {
  this.getLabelsMap().clear();
  return this;
};


/**
 * optional bool fixedQuestionDelivery = 14;
 * @return {boolean}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getFixedquestiondelivery = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setFixedquestiondelivery = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool secondChanceDelivery = 15;
 * @return {boolean}
 */
proto.sparx.packages.v1.TaskCompletion.prototype.getSecondchancedelivery = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.sparx.packages.v1.TaskCompletion} returns this
 */
proto.sparx.packages.v1.TaskCompletion.prototype.setSecondchancedelivery = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.TaskItemCompletion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.TaskItemCompletion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.TaskItemCompletion.toObject = function(includeInstance, msg) {
  var f, obj = {
    packageid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    taskindex: jspb.Message.getFieldWithDefault(msg, 2, 0),
    taskitemindex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    numcorrectanswers: jspb.Message.getFieldWithDefault(msg, 5, 0),
    numwronganswers: jspb.Message.getFieldWithDefault(msg, 6, 0),
    numvideowatched: jspb.Message.getFieldWithDefault(msg, 7, 0),
    lastansweredat: (f = msg.getLastansweredat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 9, ""),
    usestatus: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    rating: (f = msg.getRating()) && proto.sparx.packages.v1.Rating.toObject(includeInstance, f),
    numconsecutivewronganswers: jspb.Message.getFieldWithDefault(msg, 17, 0),
    labelsMap: (f = msg.getLabelsMap()) ? f.toObject(includeInstance, undefined) : [],
    numskillquestions: jspb.Message.getFieldWithDefault(msg, 19, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.TaskItemCompletion}
 */
proto.sparx.packages.v1.TaskItemCompletion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.TaskItemCompletion;
  return proto.sparx.packages.v1.TaskItemCompletion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.TaskItemCompletion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.TaskItemCompletion}
 */
proto.sparx.packages.v1.TaskItemCompletion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackageid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTaskindex(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTaskitemindex(value);
      break;
    case 4:
      var value = /** @type {!proto.sparx.packages.v1.TaskItemStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumcorrectanswers(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumwronganswers(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumvideowatched(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastansweredat(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUsestatus(value);
      break;
    case 16:
      var value = new proto.sparx.packages.v1.Rating;
      reader.readMessage(value,proto.sparx.packages.v1.Rating.deserializeBinaryFromReader);
      msg.setRating(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumconsecutivewronganswers(value);
      break;
    case 18:
      var value = msg.getLabelsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumskillquestions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.TaskItemCompletion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.TaskItemCompletion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.TaskItemCompletion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPackageid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskindex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTaskitemindex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getNumcorrectanswers();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getNumwronganswers();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getNumvideowatched();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getLastansweredat();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUsestatus();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getRating();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.sparx.packages.v1.Rating.serializeBinaryToWriter
    );
  }
  f = message.getNumconsecutivewronganswers();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getLabelsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(18, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getNumskillquestions();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
};


/**
 * optional string packageID = 1;
 * @return {string}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getPackageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setPackageid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 taskIndex = 2;
 * @return {number}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getTaskindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setTaskindex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 taskItemIndex = 3;
 * @return {number}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getTaskitemindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setTaskitemindex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional TaskItemStatus status = 4;
 * @return {!proto.sparx.packages.v1.TaskItemStatus}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getStatus = function() {
  return /** @type {!proto.sparx.packages.v1.TaskItemStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.sparx.packages.v1.TaskItemStatus} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int32 numCorrectAnswers = 5;
 * @return {number}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getNumcorrectanswers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setNumcorrectanswers = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 numWrongAnswers = 6;
 * @return {number}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getNumwronganswers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setNumwronganswers = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 numVideoWatched = 7;
 * @return {number}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getNumvideowatched = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setNumvideowatched = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp lastAnsweredAt = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getLastansweredat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
*/
proto.sparx.packages.v1.TaskItemCompletion.prototype.setLastansweredat = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.clearLastansweredat = function() {
  return this.setLastansweredat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.hasLastansweredat = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string name = 9;
 * @return {string}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool useStatus = 15;
 * @return {boolean}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getUsestatus = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setUsestatus = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional Rating rating = 16;
 * @return {?proto.sparx.packages.v1.Rating}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getRating = function() {
  return /** @type{?proto.sparx.packages.v1.Rating} */ (
    jspb.Message.getWrapperField(this, proto.sparx.packages.v1.Rating, 16));
};


/**
 * @param {?proto.sparx.packages.v1.Rating|undefined} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
*/
proto.sparx.packages.v1.TaskItemCompletion.prototype.setRating = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.clearRating = function() {
  return this.setRating(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.hasRating = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional int32 numConsecutiveWrongAnswers = 17;
 * @return {number}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getNumconsecutivewronganswers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setNumconsecutivewronganswers = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * map<string, string> labels = 18;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getLabelsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 18, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.clearLabelsMap = function() {
  this.getLabelsMap().clear();
  return this;
};


/**
 * optional int32 numSkillQuestions = 19;
 * @return {number}
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.getNumskillquestions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.TaskItemCompletion} returns this
 */
proto.sparx.packages.v1.TaskItemCompletion.prototype.setNumskillquestions = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.Rating.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.Rating.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.Rating} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.Rating.toObject = function(includeInstance, msg) {
  var f, obj = {
    confidence: jspb.Message.getFieldWithDefault(msg, 1, 0),
    confidenceafter: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.Rating}
 */
proto.sparx.packages.v1.Rating.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.Rating;
  return proto.sparx.packages.v1.Rating.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.Rating} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.Rating}
 */
proto.sparx.packages.v1.Rating.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConfidence(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setConfidenceafter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.Rating.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.Rating.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.Rating} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.Rating.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfidence();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getConfidenceafter();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 confidence = 1;
 * @return {number}
 */
proto.sparx.packages.v1.Rating.prototype.getConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.Rating} returns this
 */
proto.sparx.packages.v1.Rating.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 confidenceAfter = 2;
 * @return {number}
 */
proto.sparx.packages.v1.Rating.prototype.getConfidenceafter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.Rating} returns this
 */
proto.sparx.packages.v1.Rating.prototype.setConfidenceafter = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sparx.packages.v1.Completion.prototype.toObject = function(opt_includeInstance) {
  return proto.sparx.packages.v1.Completion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sparx.packages.v1.Completion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.Completion.toObject = function(includeInstance, msg) {
  var f, obj = {
    size: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    weight: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    progressMap: (f = msg.getProgressMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sparx.packages.v1.Completion}
 */
proto.sparx.packages.v1.Completion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sparx.packages.v1.Completion;
  return proto.sparx.packages.v1.Completion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sparx.packages.v1.Completion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sparx.packages.v1.Completion}
 */
proto.sparx.packages.v1.Completion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWeight(value);
      break;
    case 3:
      var value = msg.getProgressMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readDouble, null, "", 0.0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sparx.packages.v1.Completion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sparx.packages.v1.Completion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sparx.packages.v1.Completion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sparx.packages.v1.Completion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSize();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getProgressMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeDouble);
  }
};


/**
 * optional double size = 1;
 * @return {number}
 */
proto.sparx.packages.v1.Completion.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.Completion} returns this
 */
proto.sparx.packages.v1.Completion.prototype.setSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double weight = 2;
 * @return {number}
 */
proto.sparx.packages.v1.Completion.prototype.getWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sparx.packages.v1.Completion} returns this
 */
proto.sparx.packages.v1.Completion.prototype.setWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * map<string, double> progress = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.sparx.packages.v1.Completion.prototype.getProgressMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.sparx.packages.v1.Completion} returns this
 */
proto.sparx.packages.v1.Completion.prototype.clearProgressMap = function() {
  this.getProgressMap().clear();
  return this;
};


/**
 * @enum {number}
 */
proto.sparx.packages.v1.PackageType = {
  COMPULSORY: 0,
  OPTIONAL: 1,
  TARGETS: 2,
  PRACTICE: 6,
  ONBOARDING: 11,
  LESSON: 3,
  SOLO: 4,
  REVISION: 5,
  COMPULSORY_TRAINING: 7,
  OPTIONAL_TRAINING: 8,
  TARGETS_TRAINING: 9,
  ASSESSMENT_FIXUP: 10,
  UNUSED: 100
};

/**
 * @enum {number}
 */
proto.sparx.packages.v1.PackageStatus = {
  PLACEHOLDER: 0,
  CONTENTS_GENERATED: 1,
  GENERATION_FAILED: 2
};

/**
 * @enum {number}
 */
proto.sparx.packages.v1.TaskDeliveryFlags = {
  NONE: 0,
  DONOTWAC: 1,
  WACSNOTALLOWED: 2,
  FIXEDQUESTIONDELIVERY: 3,
  SECONDCHANCEDELIVERY: 4
};

/**
 * @enum {number}
 */
proto.sparx.packages.v1.TaskItemFlag = {
  TASK_ITEM_FLAG_UNSPECIFIED: 0,
  TASK_ITEM_FLAG_MARKING: 1,
  TASK_ITEM_FLAG_INITIALLY_HIDDEN: 2,
  TASK_ITEM_FLAG_FAST_TRACK_SKILL: 3,
  TASK_ITEM_FLAG_FTQ_TASK_QUIZ_SKILL: 4,
  TASK_ITEM_FLAG_VIDEO: 5
};

/**
 * @enum {number}
 */
proto.sparx.packages.v1.TaskItemStatus = {
  UNATTEMPTED: 0,
  DONE: 1,
  WRONG: 2,
  WARNING: 3,
  SEEKHELP: 4,
  BADGED: 5,
  HIDDEN: 6,
  WRONGWITHVIDEONUDGE: 7
};

goog.object.extend(exports, proto.sparx.packages.v1);
